/**
 * Přehled trhu — seznam měsíčních video komentářů.
 *
 * Videa běží na produkci pod chráněnou cestou (same-origin), takže je
 * přehraje jen přihlášený uživatel Portilia — URL není přeposílatelná.
 * Základ cesty lze přepsat přes REACT_APP_MARKET_MEDIA_BASE, jinak se
 * použije výchozí `/media/market` na téže doméně jako aplikace.
 *
 * Nové video = přidat soubor na server a jeden řádek do `MARKET_VIDEOS`
 * (nejnovější nahoře).
 */

export interface MarketVideo {
  /** Stabilní klíč (např. rok-měsíc), slouží jako React key. */
  id: string
  /** Nadpis karty, typicky měsíc a rok. */
  title: string
  /** Doplňkový popisek pod nadpisem. */
  subtitle?: string
  /** Zdroj videa (same-origin, chráněná cesta). */
  src: string
}

export const MARKET_MEDIA_BASE = process.env.REACT_APP_MARKET_MEDIA_BASE || '/media/market'
const MEDIA_BASE = MARKET_MEDIA_BASE

export const MARKET_VIDEOS: MarketVideo[] = [
  {
    id: '2026-09',
    title: 'Září 2026',
    subtitle: 'Blízký východ: 3 příležitosti',
    src: `${MEDIA_BASE}/apex4.mp4`,
  },
  {
    id: '2026-08',
    title: 'Srpen 2026',
    subtitle: 'Klíčové události srpna',
    src: `${MEDIA_BASE}/apex3.mp4`,
  },
  {
    id: '2026-07',
    title: 'Červenec 2026',
    subtitle: 'Komentář trhu',
    src: `${MEDIA_BASE}/apex2.mp4`,
  },
  {
    id: '2026-06',
    title: 'Červen 2026',
    subtitle: 'Komentář trhu',
    src: `${MEDIA_BASE}/apex.mp4`,
  },
]
